import { useEffect } from "react";

import { Spinner } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import useTranslation from "../../../hooks/useTranslation";
import { SubscriptionPeriod } from "../../../types";
import { getTaxLabel } from "../../../utils/currencyUtils";
import type { PriceProps } from "../PriceCard/PriceCard";

import style from "./PriceSection.module.css";

export interface PriceSectionProps {
  price?: PriceProps;
  periodPrefix?: string;
  selectedPeriod: SubscriptionPeriod;
  isLoadingPrice?: boolean;
}
const PriceSection: React.FC<PriceSectionProps> = ({
  selectedPeriod,
  isLoadingPrice,
  periodPrefix,
  price,
}) => {
  const { yearly, monthly, currencySymbol } = price ?? {};

  const { t, m } = useTranslation();
  const originalPrice =
    selectedPeriod === SubscriptionPeriod.Yearly ? Math.ceil((yearly ?? 0) / 12) : monthly;
  const displayedPeriod = t(m.Purchase.PriceMonthly);

  const taxLabel = getTaxLabel(currencySymbol);

  useEffect(() => {
    //This code takes advantage of the fact that free tier won't ever be in a loading state right now
    if (isLoadingPrice === false) {
      window.parent.postMessage({ proPrice: `${currencySymbol}${originalPrice}` }, "*");
    }
  }, [originalPrice, isLoadingPrice, displayedPeriod, currencySymbol]);
  // Left to serve as example for the discount implementation

  // const priceMonthly = props.monthly * (1 - (props.monthlyDiscountPercent ?? 0) / 100);
  // const priceYearly = props.yearly * (1 - (props.yearlyDiscountPercent ?? 0) / 100);

  // const selectedDiscount =
  //   selectedPeriod === SubscriptionPeriod.Yearly
  //     ? props.yearlyDiscountPercent
  //     : props.monthlyDiscountPercent;
  // const isDiscounted = selectedDiscount !== 0 && selectedDiscount !== undefined;
  // const selectedPrice =
  //   selectedPeriod === SubscriptionPeriod.Yearly ? Math.ceil(priceYearly / 12) : priceMonthly;
  // const formattedPriceText = `${props.currency}${selectedPrice.toFixed(0)}`;
  // const formattedPriceYearlyText = `${props.currency}${priceYearly.toFixed(2)}`;

  // const discountAppliesToFirstYearOnly =
  //   isDiscounted && selectedPeriod === SubscriptionPeriod.Yearly;
  // const displayedPeriodForDiscountedPrice = discountAppliesToFirstYearOnly
  //   ? t(m.Purchase.FirstYear)
  //   : displayedPeriod;

  return (
    <>
      {isLoadingPrice && <Spinner size="sm" />}
      {!isLoadingPrice && price && (
        <div className={style.priceSection}>
          <div className={classNames(style.price)}>
            <span className={currencySymbol && currencySymbol.length > 2 ? style.sm : ""}>
              {currencySymbol}
            </span>
            {originalPrice}
            <span className={style.period}>
              {periodPrefix}
              {displayedPeriod}
            </span>

            {originalPrice != 0 && (
              <div className={style.annually}>
                <span>
                  {selectedPeriod === SubscriptionPeriod.Yearly
                    ? `${currencySymbol}${yearly} ` +
                      t(m.Purchase.PriceBilledAnnually, { taxLabel })
                    : t(m.Purchase.PriceBilledMonthly, { taxLabel })}
                </span>
              </div>
            )}
          </div>

          {/* Left to serve as example for the discount implementation */}

          {/* {isDiscounted && (
                <h4 className={classNames(style.price, isDiscounted && style.withDiscount)}>
                  {formattedPriceText}
                  <span className={style.period}>{displayedPeriod}</span>
                  {selectedPeriod === SubscriptionPeriod.Yearly && (
                    <div className={classNames(style.annually)}>
                      <span>
                        {formattedPriceYearlyText} {t(m.Purchase.PriceBilledAnnually)}
                      </span>
                    </div>
                  )}
                  <div
                    className={classNames(
                      style.period,
                      discountAppliesToFirstYearOnly && style.temporaryDiscount
                    )}
                  >
                    {displayedPeriodForDiscountedPrice}
                  </div>
                </h4>
              )} */}
        </div>
      )}
    </>
  );
};

export default PriceSection;
